<template>
  <div>
    <div
      class="mdgridviewpage-bg mainWrap-bg applicationListPage indicatorPage"
    >
      <!-- <HeaderNew></HeaderNew> -->
      <div class="container-fluid maindivWrap pt-4">
        <div class="row">
          <div class="col-12">
            <div class="row mx-0">
              <div class="col-12 px-0">
                <div class="row mx-0">
                  <div class="col-4 px-0">
                    <form>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fa fa-search" aria-hidden="true"></i>
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Search..."
                          id
                          name
                          v-model="searchName"
                          style="border-left: 0"
                        />
                      </div>
                    </form>
                  </div>
                  <div class="col-8 px-0">
                    <div class="d-flex" style="justify-content: flex-end">
                      <div class="mx-2">
                        <form class="form-inline" action="/action_page.php">
                          <label for="" class="mr-sm-2">Show:</label>
                          <select
                            class="form-control"
                            id="sel1"
                            v-model="perPage"
                          >
                            <option>10</option>
                            <option>50</option>
                            <option>100</option>
                            <option>500</option>
                          </select>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="col-sm-12">
            <div class="listingTable mb-4">
              <div class="row mx-0">
                <div class="col-12 px-0">
                  <div class="row">
                    <div class="col-6">
                      <h5 class="section_title mt-3">Indicator Group</h5>
                    </div>
                    <div class="col-6">
                      <button
                        class="btn btn-sm float-right addTemp_btn mt-3 mr-0"
                        data-toggle="collapse"
                        href="#add_indicator_type"
                        @click="edittableforflage()"
                      >
                        <span class="border_bottom_grey">
                          <i class="fa fa-plus" aria-hidden="true"></i> Add
                          Indicator Group
                        </span>
                      </button>
                    </div>
                  </div>
                  <div class="card tableCard">
                    <div class="card-body px-0 pt-2">
                      <table
                        class="table table-striped table-hover mb-0 bg-white" style="border-radius: 10px;     box-shadow: 0px 0px 2px #ddd;"
                      >
                        <thead>
                          <tr class="row mx-0" style="border-radius: 10px 10px 0 0;">
                            <th class="col-1" style="border-top: 0">No.</th>
                            <th class="col-9" style="border-top: 0">
                              Indicator Group Name
                            </th>
                            <th class="col-2" style="border-top: 0">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            class="row mx-0"
                            v-for="(item, index) in groupList"
                          >
                            <td class="col-1">{{ index + 1 }}</td>
                            <td class="col-9">{{ item.displayName }}</td>
                            <td class="col-2">
                              <div class="iconGroup d-flex">
                                <i
                                  class="fa fa-pencil-square-o cursor-pointer"
                                  aria-hidden="true"
                                  v-b-tooltip.hover
                                  title="Edit"
                                  data-toggle="collapse"
                                  href="#add_indicator_type"
                                  @click="edittabledata(groupList[index])"
                                ></i>
                                <i
                                  class="fa fa-trash cursor-pointer"
                                  aria-hidden="true"
                                  v-b-tooltip.hover
                                  title="Delete"
                                  @click="deletetabledata(groupList[index])"
                                ></i>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="wizardCard mb-4 collapse" id="add_indicator_type">
              <div class="card shadow-sm">
                <div class="card-header">Add Indicator Type</div>
                <div class="card-body">
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorTypeName"
                          class="col-sm-3 col-form-label"
                          >Indicator Type Name</label
                        >
                        <div class="col-sm-9">
                          <input
                            type="text"
                            class="form-control"
                            v-model="indicatortypenamevalue"
                            id="indicatorTypeName"
                            placeholder
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorTypeName"
                          class="col-sm-3 col-form-label"
                          >Indicator Group list</label
                        >
                        <div class="col-sm-9">
                          <v-multiselect-listbox
                            :options="tableoptions"
                            v-model="optionsProxy"
                            :reduce-display-property="(option) => option.label"
                            :reduce-value-property="(option) => option.code"
                          >
                          </v-multiselect-listbox>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 mb-2">
                    <div class="justify-content-end d-flex w-100">
                      <button
                        class="btn btn-newprimary"
                        v-if="updatetableflag == false"
                        @click="indicatortype(savegrpdata)"
                      >
                        Save
                      </button>
                      <button
                        class="btn btn-success text-white"
                        v-if="updatetableflagfor1entry == true"
                        @click="
                          indicatortypeupdate(
                            indicatortypenamevalue,
                            optionsProxy,
                            updatedatatemp
                          )
                        "
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-sm-12">
            <div class="bottomSubmitbtn float-right mb-4">
              <button class="btn btn-newprimary">
                Next
                <i
                  class="fa fa-angle-double-right pl-2 text-white"
                  aria-hidden="true"
                ></i>
              </button>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- <training-footer></training-footer> -->
  </div>
</template>
<script>
import HeaderNew from "../components/layout/HeaderNew";
import trainingFooter from "../components/trainingFooter";
import ApiServices from "../service/ApiServices";
import vMultiselectListbox from "vue-multiselect-listbox";
import "vue-multiselect-listbox/src/scss/vue-multi-select-listbox.scss";
export default {
  components: {
    HeaderNew,
    trainingFooter,
    vMultiselectListbox,
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    // options: {
    //   type: Array,
    //   default () {
    //     return [];
    //   },
    // },
    searchOptionsPlaceholder: {
      type: String,
      default() {
        return "Search";
      },
    },
    selectedOptionsPlaceholder: {
      type: String,
      default() {
        return "Search";
      },
    },
    // reduceDisplayProperty: {
    //   type: Function,
    //   default: (value) => value,
    // },
    // reduceValueProperty: {
    //   type: Function,
    //   default: (value) => value,
    // },
    noOptionsText: {
      type: String,
      default: "",
    },
    selectedNoOptionsText: {
      type: String,
      default: "Select",
    },
    noOptionsFoundText: {
      type: String,
      default: "No options found",
    },
    noSelectedOptionsFoundText: {
      type: String,
      default: "No options found",
    },
    showSelectAllButtons: {
      type: Boolean,
      default: true,
    },
    searchInputClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      userProfile: "",
      indicatortablevalue: [],
      indicatortypenamevalue: "",
      indicatorfactor: "",
      editabledata: [],
      updatetableflag: false,
      updatedatatemp: [],
      baseUrl: "http://localhost:8080/dhis/",
      dashboardUrl: "api/apps/Avenir-Generic/index.html#/",
      options: [
        {
          value: null,
          text: "Please select an option",
          disabled: true,
        },
        {
          value: "5",
          text: "5",
        },
        {
          value: "25",
          text: "25",
        },
        {
          value: "50",
          text: "50",
        },
        {
          value: "100",
          text: "100",
        },
      ],
      perPage: 10,
      currentPage: 1,
      allAppsList: [],
      groupListLen: "",
      searchName: "",
      isView: "list",
      allAppsListLen: 0,
      tableoptions: [],
      filterededitable: [],
      savegrpdata: {
        name: "",
        indicators: [],
      },
      reduceDisplayProperty: {
        type: Function,
        default: (value) => value,
      },
      reduceValueProperty: {
        type: Function,
        default: (value) => value,
      },
      updatetableflagfor1entry: true,
      optionsProxy: [],
    };
  },
  watch: {
    optionsProxy: function (val, oldVal) {
      console.log(val);
      this.savegrpdata = {
        name: "",
        indicators: [],
      };
      this.savegrpdata.name = this.indicatortypenamevalue;
      for (var i in val) {
        this.savegrpdata.indicators.push({
          id: val[i].code,
        });
      }
    },
  },
  computed: {
    groupList() {
      let filteredApps = this.indicatortablevalue.filter(
        (a) =>
          a.displayName &&
          a.displayName.toLowerCase().includes(this.searchName.toLowerCase())
      );
      // console.log("filteredApps",filteredApps)
      this.groupListLen = filteredApps.length;
      return filteredApps.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    rows() {
      return this.allAppsList.length;
    },
  },
  methods: {
    edittableforflage() {
      this.updatetableflag = false;
      this.updatetableflagfor1entry = false;
      this.indicatortypenamevalue = "";
      this.optionsProxy = [];
    },
    gotoApp(appId, appUserId) {
      window.open(
        `http://localhost:8080/#/?appId=${appId}&appUserId=${appUserId}`,
        "_blank"
      );
    },
    edittabledata(data) {
      //console.log(data)
      this.updatetableflagfor1entry = true;
      this.updatetableflag = true;
      this.filterededitable = [];
      ApiServices.RestGetCall(
        "api/indicatorGroups/" +
          data.id +
          "?fields=%3Aall%2CattributeValues%5B%3Aall%2Cattribute%5Bid%2Cname%2CdisplayName%5D%5D",
        {}
      ).then((res) => {
        console.log(res);
        this.updatedatatemp = res;

        var tableoptionstemp = [];
        tableoptionstemp = this.tableoptions;
        for (var j in tableoptionstemp) {
          for (var i in res.indicators) {
            if (tableoptionstemp[j].code == res.indicators[i].id) {
              this.filterededitable.push(tableoptionstemp[j]);
            }
          }
        }
      });

      this.optionsProxy = this.filterededitable;
      console.log(this.filterededitable);
      this.indicatortypenamevalue = data.displayName;
    },
    indicatortypeupdate(name, factor, value) {
      console.log(name, factor, value);

      value.indicators = [];

      for (var i in factor) {
        var obj = {};
        obj.id = factor[i].code;
        value.indicators.push(obj);
      }

      console.log(value);

      ApiServices.RestPutCall(
        "api/indicatorGroups/" + value.id + "?mergeMode=REPLACE",
        value
      ).then((res) => {
        console.log(res);
        this.$router.go();
      });
    },
    deletetabledata(data) {
      console.log(data);

      ApiServices.RestDeleteCall("api/indicatorGroups/" + data.id).then(
        (res) => {
          console.log(res);
          this.$router.go();
        }
      );
    },

    indicatortype(name) {
      console.log(name);

      ApiServices.RestPostCall("api/indicatorGroups", name).then((res) => {
        console.log(res);
        this.$router.go();
      });
    },
    logout() {
      //dhis-web-commons-security/logout.action
      localStorage.removeItem("userProfile");
      localStorage.removeItem("loggedInUserId");
      ApiServices.RestGetCall(
        "dhis-web-commons-security/logout.action",
        {}
      ).then((res) => {
        console.log(res);
      });
      //window.open('http://intraavenir.duredemos.com/service/dhis-web-commons-security/logout.action', '_blank');
      this.$router.push("/");
    },
    getAllApps() {
      console.log(this.$root);
      this.$root.loading = true;
      ApiServices.getAllKeys()
        .then(async (response) => {
          console.log(response);
          let filteredApps = [];

          response.data.forEach((a) => {
            let keyName = a.split("_");
            if (a.includes("applicationModule") && keyName.includes("en")) {
              filteredApps.push(a);
            }
          });

          await ApiServices.RestGetCall(
            "/api/avenir/training/getTrainingApps"
          ).then((response) => {
            console.log("Training response", response.trainingApp);
            response.trainingApp.forEach((t) => {
              this.allAppsList.push(t);
            });
          });
          if (filteredApps.length) {
            filteredApps.forEach(async (f, i) => {
              let appResponse = await ApiServices.getSavedConfig(f);
              this.allAppsList.push(appResponse.data);
              if (this.allAppsList.length === filteredApps.length) {
                this.$root.loading = false;
                console.log("apps List", this.allAppsList);
              }
            });
          }
        })
        .catch((res) => (this.$root.loading = false));
    },
  },
  mounted() {
    this.userProfile = JSON.parse(localStorage.getItem("userProfile"));
    this.baseUrl = ApiServices.getBaseUrl();
    this.dashboardUrl = this.baseUrl + this.dashboardUrl;
    //  this.getAllApps();
    ApiServices.RestGetCall("api/indicatorGroups", {}).then((res) => {
      console.log(res);
      this.indicatortablevalue = res.indicatorGroups;
    });

    ApiServices.RestGetCall(
      "api/indicators?filter=name:ne:default&fields=displayName%7Crename(name)%2Cid%2Clevel&paging=false",
      {}
    ).then((res) => {
      console.log(res);

      for (var i in res.indicators) {
        var obj = {};
        obj.label = "";
        obj.code = "";
        obj.label = res.indicators[i].name;
        obj.code = res.indicators[i].id;

        this.tableoptions.push(obj);
      }
      console.log(this.tableoptions);
    });
  },
};
</script>
<style scoped lang="scss">
.mainWrap-bg {
  background-color: #f4f4f4 !important;
  background-image: none;
  /* background-size: cover;
  background-position: center; */
  min-height: 100vh;
  /* padding: 20px 40px; */
  padding: 10px 20px;
}
.maindivWrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.form-control {
  background-color: transparent !important;
}
.tableCard {
  .table {
    thead {
      tr {
        background: #2e3f53;
        th {
          color: #fff;
        }
      }
    }
  }
}
table tbody {
  border-radius: 0px 0px 10px 10px;
}
table tbody tr:last-child td:nth-last-child(1) {
  border-radius: 0px 0px 10px 0px;
}
table tbody tr:last-child td:nth-last-child(4) {
  border-radius: 0px 0px 0px 10px;
}
</style>
